<template>
  <!-- 上拉多选组件 -->
  <div class="drop_down">
    <van-popup
      :value="value"
      @input="val => this.$emit('input', val)"
      position="bottom"
      :overlayStyle="{background: 'rgba(0, 0, 0, .3)'}"
    >
      <div class="pop_cont">
        <div class="header">
          <div class="tip">{{tipText}}</div>
          <div class="drop" @click="close">
            <img src="@/assets/appraise/arrow_btm.png" alt />
          </div>
        </div>
        <div class="content">
          <van-checkbox-group v-model="checkItems">
            <div class="cont_item" v-for="(item, index) in dataList" :key="index">
              <div class="name">{{item.name}}</div>
              <van-checkbox :name="item" class="check" :disabled="item.area == $route.query.area" checked-color="#36B374">
                <template #icon="props">
                  <img v-if="props.checked&&item.area == $route.query.area" style="width: 18px;" src="@/assets/appraise/unactive.jpg" :disabled="item.area == $route.query.area" alt="">
                  <img v-else-if="props.checked" style="width: 18px;" :disabled="item.area == $route.query.area" src="@/assets/appraise/active.jpg" alt="">
                  <img v-else-if="!props.checked" style="width: 18px;" src="@/assets/appraise/inactive.jpg" alt="">
                </template>
              </van-checkbox>
              
            </div>
          </van-checkbox-group>
        </div>
        <div class="footer">
          <van-button @click="confirm" type="primary" size="large">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    tipText: {
      type: String,
      default: () => {
        return "选择州市";
      }
    },
    value: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      checkItems: []
    };
  },
  mounted() {
    console.log(this.checkItems,'checkItems')
  },
  methods: {
    // 成功回调
    confirm() {
      this.$emit('confirm', this.checkItems);
    },
    cancel() {},
    close() {
      
    }
  }
};
</script>

<style scoped lang="less">
.van-popup {
  max-height: 561px;  
}
.pop_cont {
  padding: 0 12px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tip {
      padding: 16px 0 10px;
      color: #333;
      font-size: 16px;
      font-weight: 600;
    }
  }
  .cont_item {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    border-bottom: 1px solid #eee;
    .name {
      color: #333;
      font-size: 16px;
      line-height: 18px;
      font-weight: 400;
    }
    .check {

    }
  }
  .content {
    padding-bottom: 60px;
    max-height: 459px;
    overflow: auto;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 10px 12px;
    width: 100%;
    height: 60px;
    background-color: #fff;
    .van-button {
      width: 351px;
      height: 40px;
      background-color: #36b374;
    }
  }
}
</style>